__turbopack_context__.v({
  "rating": "ZPTaCa_rating",
});
